//track order js

function waitForElm(selector) {
    return new Promise(resolve => {
if (document.querySelector(selector)) {
    return resolve(document.querySelector(selector));
}

const observer = new MutationObserver(mutations => {
    if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
    }
});

observer.observe(document.body, { childList: true, subtree: true });
    });
}

// waitForElm('.jdgm-histogram__row').then(() => {
//     const rows = document.querySelectorAll('.jdgm-histogram__row');

//     if (rows.length >= 5) {
// rows.forEach((row, index) => {
//     if (index < 5) {
//         const paragraph = document.createElement('p');
//         paragraph.textContent = `${5 - index} star${5 - index > 1 ? 's' : ''}`;
//         paragraph.classList.add('rating-count');
//         row.prepend(paragraph);
//     }
// });
//     } else {
// console.error('Less than 5 jdgm-histogram__row elements found');
//     }
// });

document.addEventListener("DOMContentLoaded", function() {
    const inputs = document.querySelectorAll('.PP-TextField__Input');

    if (inputs && inputs.length > 0) {
if (inputs[0]) inputs[0].placeholder = 'Order Number';
if (inputs[1]) inputs[1].placeholder = 'Email';
if (inputs[2]) inputs[2].placeholder = 'Tracking Number';
    }

    const buttons = document.querySelectorAll('.pp-button-enter');

    if (buttons && buttons.length > 0) {
buttons.forEach(button => {
    button.innerHTML = `
        Track my order
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.5 8.5L9.5 3.5L8.795 4.205L12.585 8L2.5 8L2.5 9L12.585 9L8.795 12.795L9.5 13.5L14.5 8.5Z" fill="white"/>
        </svg>
    `;
});
    }
});
//end of track order js
